export const BASE_URL = import.meta.env.VITE_API_BASE_URL;
export const IMG_PREFIX = import.meta.env.VITE_IMG_PREFIX;
export const WECHAT_QQ_LOGIN_ORIGIN = import.meta.env
  .VITE_WECHAT_QQ_LOGIN_ORIGIN;
/**
 * 埋点 appId
 */
export const ENV_THINKING_DATA_APP_ID = import.meta.env
  .VITE_ENV_THINKING_DATA_APP_ID;

/**
 * 埋点 server url
 */
export const ENV_THINKING_DATA_SERVER_URL = import.meta.env
  .VITE_ENV_THINKING_DATA_SERVER_URL;

// export const BASE_URL = 'https://api-fatetrigger.sarosgame.com'; // 测试用
// export const IMG_PREFIX = 'https://static-grwebsite-fatetrigger.sarosgame.com'; // 测试用
